export const COUNTER_VIEWS_TITLE = "Количество просмотров";